import client from './client';

export const debtDetail = () => client.get('/debts/detail').then((r) => r.data);
export const debtGroup = () => client.get('/debts/group').then((r) => r.data);
export const debtByCustomer = (customerNo) => client.get(`/debts/customer/${customerNo}`).then((r) => r.data);
export const sendDebtReport = () => client.post('/debts/report').then((r) => r.data);
export const listDebtReports = () => client.get('/debts/reports').then((r) => r.data);
export const getDebtReport = (id) => client.get(`/debts/reports/${id}`).then((r) => r.data);

// Công nợ cước nội địa + NVL (quét /api/checkins + /api/structions/bill server-side).
export const getDomesticFees = () => client.get('/debts/domestic-fees').then((r) => r.data);
export const scanDomesticFees = (from, to) => client.post('/debts/domestic-fees/scan', { from, to }).then((r) => r.data);

// Tỷ lệ thu hồi công nợ tuần các chi nhánh.
export const getDebtRecovery = () => client.get('/debts/recovery').then((r) => r.data);
export const saveDebtRecovery = (rows) => client.put('/debts/recovery', { rows }).then((r) => r.data);
export const scanRecoveryRevenue = (from, to) => client.post('/debts/recovery/scan-revenue', { from, to }).then((r) => r.data);
export const getRecoveryScanStatus = () => client.get('/debts/recovery/scan-status').then((r) => r.data);
export const closeDebtRecovery = () => client.post('/debts/recovery/close').then((r) => r.data);

// Quét công nợ ĐẦY ĐỦ (COD + cước/NVL + doanh thu tuần) + trạng thái auto 16:30 thứ 5.
export const scanFinanceFull = () => client.post('/debts/scan-full').then((r) => r.data);
export const getFinanceScanStatus = () => client.get('/debts/scan-status').then((r) => r.data);
